var COOKIE = {
    //写cookies
    setCookie(name, value, day) {
        var date = new Date();
        date.setDate(date.getDate() + day);
        document.cookie = name + "="+ value + ";expires=" + date + ";domain=.yxdxt.com;path=/";
        console.log('setCookie--------', name, value)
        console.log('------', document.cookie)
    },
    //读取cookies
    getCookie(name) {
        var arr, 
            reg = RegExp(name + '=([^;]+)');
            arr = document.cookie.match(reg)
        console.log('getCookie--------', arr)
        if(arr && arr.length) {
            return arr[1];
        }else {
            return null;
        }
    }
}
export {
    COOKIE
}